/* unplugin-vue-components disabled */import { render } from "./CTypeTab.vue?vue&type=template&id=bea612e6&scoped=true&ts=true"
import script from "./CTypeTab.vue?vue&type=script&lang=ts"
export * from "./CTypeTab.vue?vue&type=script&lang=ts"

import "./CTypeTab.vue?vue&type=style&index=0&id=bea612e6&scoped=true&lang=less"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bea612e6"]])

export default __exports__